import { FlexCenterBoth } from 'components/primitives/flex';
import { Text } from 'components/primitives/typography';
import { useAtom } from 'jotai';
import styled, { css } from 'styled-components';
import useRudderStackTrack from 'hooks/useRudderStackTrack';
import { Box } from 'components/primitives/box';

export const renderAtomCheckButton = ({ value, label, checkedAtom }) => (
  <AtomCheckButton key={value} checkedAtom={checkedAtom} label={label} />
);

export const CheckIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3334 4L6.00008 11.3333L2.66675 8"
      stroke="#0751C2"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default function AtomCheckButton({ label, checkedAtom }) {
  const [checked, toggleChecked] = useAtom<boolean, () => void, void>(checkedAtom);

  const rudderTrack = useRudderStackTrack();

  function handleClick() {
    toggleChecked();
    rudderTrack('checkbox_toggle_search', {
      value: !checked,
      label,
    });
  }

  return (
    <CheckButton checked={checked} onClick={() => handleClick()}>
      <Text fSize="14px" fWeight="500">
        {label}
      </Text>
      {checked && (
        <IconWrapper>
          <CheckIcon />
        </IconWrapper>
      )}
    </CheckButton>
  );
}

export const CheckButton = styled(FlexCenterBoth)<{ checked: boolean }>`
  border: 1px solid #eef1f5;
  border-radius: 8px;
  cursor: pointer;
  padding: 12px 16px;
  text-align: center;
  min-width: 50px;

  &:hover {
    background-color: #f8f9fa;
    border-color: #eef1f5;
  }

  ${({ checked }) =>
    checked &&
    css`
      background: #e9f1fc;
      border-color: #e9f1fc;
      color: #0751c2;

      &:hover {
        background: #e9f1fc;
        border-color: #e9f1fc;
        color: #0751c2;
      }
    `};
`;

export const IconWrapper = styled(Box)`
  padding-left: 8px;
  display: flex;
`;
